import React from 'react';
import useSeo from '../seo';

const INDUSTRIES = [
  { icon: '🏭', name: 'Manufacturing', body: 'Utilise the full stack to track the molecule of raw material through the factory, manage complex shift planning and costing, and route to the customer.', config: 'Full Stack · Modules 1–9' },
  { icon: '⛏️', name: 'Mining', body: 'Leverage Input Costing and CAPEX to manage heavy machinery, extraction phase costing, and secure paycost budgets for large workforces.', config: 'Extraction Focus · Modules 1, 2, 5, 7, 8' },
  { icon: '📦', name: 'Distribution', body: 'Focus on inbound logistics, warehouse shift planning and costing, and moving goods at scale without paying for manufacturing logic.', config: 'Logistics Focus · Modules 1, 2, 4, 7, 8, 9' },
  { icon: '🛒', name: 'Retail', body: 'Budget store-level OPEX per square meter, land stock from port to central warehouse, plan DC-to-store replenishment, and set shelf prices off the true cost of buying, storing and staffing — with manufacturing logic switched off.', config: 'Store & Shelf Focus · Modules 1, 2, 4, 6, 7, 8, 9' },
];

const Industries = () => {
  useSeo('/industries');

  return (
    <section className="mn-section" id="industries">
      <div className="mn-container">
        <div className="mn-section-head">
          <span className="mn-kicker">Built for the Physical World</span>
          <h1>One platform that morphs to your value chain</h1>
          <p>Mantle is the first planning tool built specifically to mirror the physical supply chain.</p>
        </div>
        <div className="mn-grid-2">
          {INDUSTRIES.map((i) => (
            <div className="mn-card" key={i.name}>
              <div className="mn-card-icon">{i.icon}</div>
              <h3>{i.name}</h3>
              <p>{i.body}</p>
              <span className="mn-config">{i.config}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;